import React from 'react';
import { formattedDateTime } from 'shared/utils/date';

export interface SESEventLog {
  eventType: 'Bounce' | 'Click' | 'Delivery' | 'Open' | 'Send';
  source: string;
  timeStamp: string;
  sendingAccountId: string;
  messageId: string;
  destination: string;
  fromEmail: string;
  toEmail: string;
  subject: string;
  body?: string;
  emailType: string;
  // open event
  openTimeStamp?: string;
  openIpAddress?: string;
  openUserAgent?: string;
  // delivery event
  deliveryTimeStamp?: string;
  deliveryProcessingTimeMillis?: number;
  deliveryRecipients?: string;
  deliverySmtpResponse?: string;
  deliveryReportingMTA?: string;
}

export const userInfoProperties: (keyof SESEventLog)[] = [
  'eventType',
  'emailType',
  'subject',
  'destination',
  'timeStamp',
  'source',
  'sendingAccountId',
  'fromEmail',
  'toEmail',
];

export const messageInfoProperties: (keyof SESEventLog)[] = [
  'messageId',
  'openTimeStamp',
  'openIpAddress',
  'openUserAgent',
  'deliveryTimeStamp',
  'deliveryRecipients',
  'deliverySmtpResponse',
  'deliveryReportingMTA',
  'deliveryProcessingTimeMillis',
];

export const getSESLogInfo = (
  event: SESEventLog,
  array: (keyof SESEventLog)[],
) => {
  const result: {
    info: React.ReactNode;
    label: React.ReactNode;
  }[] = [];
  for (const i of array) {
    switch (i) {
      case 'eventType':
        event.eventType &&
          result.push({
            label: 'Event Type',
            info: event.eventType,
          });
        break;
      case 'emailType':
        event.emailType &&
          result.push({
            label: 'Email Type',
            info: event.emailType,
          });
        break;
      case 'subject':
        event.subject &&
          result.push({
            label: 'Subject',
            info: event.subject,
          });
        break;
      case 'destination':
        event.destination &&
          result.push({
            label: 'Destination',
            info: event.destination,
          });
        break;
      case 'timeStamp':
        event.timeStamp &&
          result.push({
            label: 'Time Stamp',
            info: formattedDateTime(event.timeStamp),
          });
        break;
      case 'source':
        event.source &&
          result.push({
            label: 'Source',
            info: event.source,
          });
        break;
      case 'sendingAccountId':
        event.sendingAccountId &&
          result.push({
            label: 'Sending Account Id',
            info: event.sendingAccountId,
          });
        break;
      case 'messageId':
        event.messageId &&
          result.push({
            label: 'Message Id',
            info: event.messageId,
          });
        break;
      case 'fromEmail':
        event.fromEmail &&
          result.push({
            label: 'From',
            info: event.fromEmail,
          });
        break;
      case 'toEmail':
        event.toEmail &&
          result.push({
            label: 'To',
            info: event.toEmail,
          });
        break;
      case 'openTimeStamp':
        event.openTimeStamp &&
          result.push({
            label: 'Open Time Stamp',
            info: formattedDateTime(event.openTimeStamp),
          });
        break;
      case 'openIpAddress':
        event.openIpAddress &&
          result.push({
            label: 'Open IP Address',
            info: event.openIpAddress,
          });
        break;
      case 'openUserAgent':
        event.openUserAgent &&
          result.push({
            label: 'Open User Agent',
            info: event.openUserAgent,
          });
        break;
      case 'deliveryTimeStamp':
        event.deliveryTimeStamp &&
          result.push({
            label: 'Delivery Time Stamp',
            info: formattedDateTime(event.deliveryTimeStamp),
          });
        break;
      case 'deliveryRecipients':
        event.deliveryRecipients &&
          result.push({
            label: 'Delivery Recipients',
            info: event.deliveryRecipients,
          });
        break;
      case 'deliverySmtpResponse':
        event.deliverySmtpResponse &&
          result.push({
            label: 'Delivery Smtp Response',
            info: event.deliverySmtpResponse,
          });
        break;
      case 'deliveryReportingMTA':
        event.deliveryReportingMTA &&
          result.push({
            label: 'Delivery Reporting MTA',
            info: event.deliveryReportingMTA,
          });
        break;
      case 'deliveryProcessingTimeMillis':
        event.deliveryProcessingTimeMillis &&
          result.push({
            label: 'Delivery Processing Time Millis',
            info: event.deliveryProcessingTimeMillis,
          });
        break;

      default:
        break;
    }
  }
  return result;
};
